import "../../styles/auth/auth.css";

const ErrorText = (props = {}) => {
  const { error } = props;

  return <>{error && <p className="form-error">{error}</p>}</>;
};

export default ErrorText;
